import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, CloseReason, Icon, SpeedDial, SpeedDialAction, SpeedDialIcon, SxProps, Theme } from '@mui/material';
import { useGenerateUuid } from 'hooks/useGenerateUuid';
import { useCallback, useState } from 'react';
import { useAppSelector } from 'redux/hooks';
import { theme } from 'theme';
import useCustomLocation from 'utils/useCustomLocation';

export type ActionProps = {
    id?: string;
    label: string;
    icon: string;
    onClick: () => void;
    disabled?: () => boolean;
};

export type FloatingActionsProps = {
    id?: string;
    actions: Array<ActionProps>;
    mainButttonSx?: SxProps<Theme>;

    backdropProps?: {
        invisible?: boolean;
        zIndex?: number;
    };
    onClose?: (reason: CloseReason) => void;
};

const FloatingActions = (props: FloatingActionsProps) => {

    const [randomUuid] = useGenerateUuid();
    const [open, setOpen] = useState(false);
    const { cliente } = useAppSelector(s => s.state.pedido);
    const { isTelaRegistraVenda } = useCustomLocation();

    const isDisabled = useCallback((a: ActionProps) => {
        if (!cliente?.descritivo && a.label === "Finalizar venda NF-e") {
            return true;
        }
        return a.disabled?.() ?? false;
    }, [cliente]);

    return (
        <>
            <Backdrop
                onClick={() => setOpen(false)}
                invisible={props.backdropProps?.invisible ?? false}
                open={open}
                sx={{ zIndex: props.backdropProps?.zIndex ?? 10 }}
            />
            <SpeedDial
                onClose={(_, r) => { props.onClose?.(r); }}
                id={props.id ? props.id : randomUuid()}
                ariaLabel="Floating actions"
                sx={props.mainButttonSx
                    ? props.mainButttonSx
                    : {
                        marginBottom: '-3px', zIndex: 10,
                        transform: 'translateY(-3px)',
                    }
                }
                icon={<SpeedDialIcon icon={<Icon baseClassName={'fa-solid fa-notes-medical'} />} openIcon={<CloseIcon />} />}
                onClick={() => setOpen(prev => !prev)}
                open={open}
                FabProps={{
                    size: 'medium',
                    sx: {
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': {
                            backgroundColor: theme.palette.primary.main,
                            filter: 'grayscale(.2) brightness(.8) contrast(1.5)'
                        },
                    }
                }}
            >
                {props.actions.filter(s => isTelaRegistraVenda() || !(s.label === "Brinde (Alt + B)"))
                    .map(a => (
                        <SpeedDialAction
                            id={a.id ? a.id : randomUuid({ prefix: 'action-' })}
                            key={randomUuid()}
                            sx={{
                                '& .MuiSpeedDialAction-staticTooltipLabel': {
                                    whiteSpace: 'nowrap'
                                },
                                '.MuiSpeedDialAction-staticTooltipLabel': {
                                    backgroundColor: isDisabled(a) ? theme.palette.text.disabled : theme.palette.background.default,
                                },
                                cursor: isDisabled(a) ? 'not-allowed' : 'pointer'
                            }}
                            icon={<i className={a.icon} style={{ fontSize: '20px', color: theme.palette.primary.main }} />}
                            FabProps={{ disabled: isDisabled(a) }}
                            tooltipTitle={a.label}
                            tooltipOpen
                            onClick={!isDisabled(a) ? a.onClick : () => { }}
                        />
                    ))}
            </SpeedDial >
        </>
    );
};

export default FloatingActions;
